import { CALL_SORTED_API } from 'gwx-voyager-components';
import Schemas from './invitations.schema';


const fetchInvitation = (id) => ({
	[CALL_SORTED_API]: {
		types: ['INVITATION_REQUEST', 'INVITATION_SUCCESS', 'INVITATION_FAILURE'],
		endpoint: `invitations/${id}`,
		schema: Schemas.INVITATION,
		mapActionToStateKey: 'invitation'
	}
});

export const loadInvitation = (id) => (dispatch) => dispatch(fetchInvitation(id));

const GET_INVITATIONS = [
	'INVITATIONS_REQUEST',
	'INVITATIONS_SUCCESS',
	'INVITATIONS_FAILURE'
];

const fetchInvitations = (query) => ({
	[CALL_SORTED_API]: {
		types: GET_INVITATIONS,
		endpoint: 'invitations',
		schema: Schemas.INVITATIONS,
		query,
		mapActionToStateKey: 'invitations'
	}
});

export const loadInvitations = (query) => (dispatch) => dispatch(fetchInvitations(query));

const ACCEPT_INVITATION = [
	'ACCEPT_INVITATION_REQUEST',
	'ACCEPT_INVITATION_SUCCESS',
	'ACCEPT_INVITATION_FAILURE'
];

const DECLINE_INVITATION = [
	'DECLINE_INVITATION_REQUEST',
	'DECLINE_INVITATION_SUCCESS',
	'DECLINE_INVITATION_FAILURE'
];

const putInvitation = (id, body) => ({
	[CALL_SORTED_API]: {
		types: body.status === 2 ? ACCEPT_INVITATION : DECLINE_INVITATION,
		endpoint: `invitations/${id}`,
		body,
		method: 'PUT',
		schema: Schemas.INVITATION,
		mapActionToStateKey: 'invitation'
	}
});

export const updateInvitation = (id, body) => (dispatch) => dispatch(putInvitation(id, body));

export const InvitationActionTypes = {
	ACCEPT_INVITATION,
	DECLINE_INVITATION,
	GET_INVITATIONS
};
